import "./trazabilidad.css";
import baner from "../../icons/bannerTurq.png";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { TabView, TabPanel } from "primereact/tabview";
import ScannerUnico from "../../ComponentesGlobales/ScannerUnico";
import qr from "../../icons/qr.png";
import { useStoreTrazabilidad } from "./StoreTrazabilidad";
import { useEffect, useState } from "react";
import { useStoreHome } from "../../paginas/Home/useStoreHome";
import {
  enumReporteSeleccionado,
  MensajeToastAdvertencia,
  MensajeToastError,
} from "../FuncionesLocales";
import TrazabilidadPorLote from "./TrazabilidadPorLote";
import TrazabilidadPorProduccion from "./TrazabilidadPorProduccion";

export default function Trazabilidad() {
  const Lectura = useStoreTrazabilidad((state) => state.Lectura);
  const Leyendo = useStoreTrazabilidad((s) => s.Leyendo);
  const clavesOcultas = useStoreTrazabilidad((s) => s.clavesOcultas);

  const deviceConsentimiento = useStoreHome(
    (state) => state.deviceConsentimiento
  );
  const deviceInfoHome = useStoreHome((s) => s.deviceInfo);
  const [showQRScanner, setShowQRScanner] = useState(false);
  const Datos = useStoreTrazabilidad((s) => s.Datos);

  const [searchClave, setSearchClave] = useState("");
  const [Entrolectura, setEntroLectura] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openQRScanner = () => {
    if (deviceConsentimiento !== "granted") {
      MensajeToastAdvertencia(
        "Habilitá permisos en el Home para usar la cámara.",
        3000
      );
      return;
    }
    if (!window.isSecureContext) {
      MensajeToastAdvertencia(
        "La cámara funciona solo en https o localhost (no en 192.168.x.x http).",
        4000
      );
      return;
    }
    if (!navigator.mediaDevices?.getUserMedia) {
      MensajeToastError("Tu navegador no soporta acceso a cámara.", 3000);
      return;
    }
    setShowQRScanner(true);
  };

  const closeQRScanner = () => {
    console.log("🚪 Cerrando QR Scanner desde EntradasTab1...");
    setShowQRScanner(false);

    // Limpieza adicional de seguridad para cualquier video elemento que pueda quedar
    setTimeout(() => {
      try {
        const videos = Array.from(document.querySelectorAll("video"));
        videos.forEach((video, index) => {
          const stream = video.srcObject;
          if (stream?.getTracks) {
            const tracks = stream.getTracks();
            tracks.forEach((track) => {
              if (track.readyState === "live") {
                track.stop();
              }
            });
          }
          video.srcObject = null;
          video.src = "";
        });
      } catch (cleanupError) {}
    }, 100);
  };

  const [lastQrValue, setLastQrValue] = useState("");

  useEffect(() => {
    useStoreHome.setState({
      ReportesSeleccionado: enumReporteSeleccionado.TRAZABILIDAD,
    });
  }, []);

  useEffect(() => {
    // Calcular el índice correcto del tab "Por Lote"
    // Si DatosBarra existe, "Info Codbar" está en índice 0 y "Por Lote" en índice 1
    // Si DatosBarra NO existe, "Por Lote" está en índice 0
    if (Datos) {
      const porLoteIndex = Datos?.DatosBarra?.length > 0 ? 1 : 0;
      setActiveIndex(porLoteIndex);
    }
  }, [Datos]);

  const handleQRScan = (result) => {
    // Verificaciones para evitar doble escaneo
    if (Entrolectura) {
      return;
    }

    // Evitar el mismo código QR en un corto período de tiempo
    if (lastQrValue === result) {
      return;
    }

    setEntroLectura(true);
    setLastQrValue(result);

    try {
      useStoreTrazabilidad.setState({ Lectura: result });
      setShowQRScanner(false);
      useStoreTrazabilidad.getState().getTrazabilidad(result);
    } catch (error) {
      MensajeToastError("Ocurrió un error al procesar el código QR.", 4000);
    } finally {
      // Permitir nuevo escaneo después de un retraso más largo
      setTimeout(() => {
        setEntroLectura(false);
      }, 1500);

      // Limpiar el último QR después de un tiempo para permitir re-escaneo del mismo código
      setTimeout(() => {
        setLastQrValue("");
        // console.log('🔄 Cache de QR limpiado');
      }, 5000);
    }
  };

  // 🔄 Renombres opcionales para ciertas claves
  const renombres = {
    Codbar: "QR",
    GeneracionRegistro: "Fecha Generación",
    PesoBruto: "Peso Bruto",
    Unidad: "Unidad de Medida",
    MercaderiaDescripcion: "Descripción del Producto",
    FechaProduccion: "Fecha de Producción",
    HoraImpresion: "Hora de Impresión",
    LoteSalida: "Lote de Salida",
    MercaderiaEAN: "EAN",
    
  };

  const esValorVacioOCero = (valor) => {
    if (valor === null || valor === undefined) return true;

    const s = String(valor).trim();

    // vacío
    if (s === "") return true;

    // si es numérico y da 0 (0, 0.0, 0.000, 000, etc.)
    const num = Number(s.replace(",", ".")); // por si viene con coma
    if (!isNaN(num) && num === 0) return true;

    return false;
  };

 

  return (
    <>
      <div className="trazabilidad-container">
        <h1 className="titulo-trazabilidad">TRAZABILIDAD</h1>

        <BlockUI
          blocked={Leyendo}
          template={
            <ProgressSpinner
              style={{ width: "24px", height: "24px", color: "white" }}
              strokeWidth="8"
              animationDuration="5.15s"
            />
          }
        >
          <div className="desp-campo-qr entradas">
            <div className="codbar-search-container">
              <input
                type="text"
                style={{ 
                  marginTop: '25px',
                  width: "350px"}}
                placeholder="Escanear QR o ingresar lote..."
                value={Lectura}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && Lectura.trim()) {
                    useStoreTrazabilidad
                      .getState()
                      .getTrazabilidad(e.target.value.trim());
                  }
                }}
                onChange={(e) => {
                  useStoreTrazabilidad.setState({ Lectura: e.target.value });
                }}
                className="codbar-search-input"
              />
            </div>

            <img
              src={qr}
              alt="qr"
              className="qr clickable"
              onClick={
                deviceConsentimiento === "granted" ? openQRScanner : undefined
              }
              title={
                deviceConsentimiento === "granted"
                  ? "Abrir escáner QR"
                  : "Necesita permiso en Home"
              }
              style={{
                cursor:
                  deviceConsentimiento === "granted"
                    ? "pointer"
                    : "not-allowed",
                    justifySelf: 'center',
                opacity: deviceConsentimiento === "granted" ? 1 : 0.4,
              }}
            />
          </div>
        </BlockUI>

        <div className="descripcion-trazabilidad">
          <h3 style={{ fontWeight: "bold", margin: "10px 0" }}>
            Reporte de Trazabilidad:
          </h3>

          <div>
            <p>
              Ingresando un número de lote o escaneando un QR, vas a poder
              acceder al recorrido completo de cada producción:
            </p>
            <p>
              Qué proceso se llevó a cabo, qué materias primas se utilizaron,
              cuál fue el producto obtenido y a quién se despachó.
            </p>
          </div>

          <h4 style={{ fontWeight: "bold", margin: "10px 0" }}>
            Una herramienta clave para verificar, auditar o responder consultas
            con precisión.
          </h4>
        </div>

        {/* TabView con tres solapas */}
        {Datos?.DatosBarra?.length > 0 ? (
          <TabView
            className="trazabilidad-tabview"
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <TabPanel header="Info QR">
              <div className="tab-content">
                <div className="codbar-search-container">
                  <input
                    type="text"
                    placeholder="Buscar por clave..."
                    value={searchClave}
                    onChange={(e) => setSearchClave(e.target.value)}
                    className="codbar-search-input"
                  />
                </div>

                <div className="codbar-list">
                  {Datos.DatosBarra
 
                    // ❌ No mostrar claves internas
                    .filter((item) => !clavesOcultas.includes(item.Clave))

                    // 🔍 Filtro por búsqueda
                    .filter(
                      (item) =>
                        !searchClave ||
                        item.Clave?.toLowerCase().includes(
                          searchClave.toLowerCase()
                        )
                    )

                    .map((item, index) => {
                      const claveMostrada = renombres[item.Clave] || item.Clave;
                      return (
                        <div key={index} className="codbar-item">
                          <div className="codbar-clave">{claveMostrada}</div>
                          <div className="codbar-valor">{item.Valor}</div>
                        </div>
                      );
                    })}

                  {Datos.DatosBarra.filter(
                    (item) =>
                      !searchClave ||
                      item.Clave?.toLowerCase().includes(
                        searchClave.toLowerCase()
                      )
                  ).length === 0 && (
                    <div className="codbar-no-results">
                      No se encontraron resultados para "{searchClave}"
                    </div>
                  )}
                </div>
              </div>
            </TabPanel>

            <TabPanel header="Por Lote">
              <TrazabilidadPorLote Datos={Datos} />
            </TabPanel>

            <TabPanel header="Por Proceso">
              <TrazabilidadPorProduccion Datos={Datos} />
            </TabPanel>
          </TabView>
        ) : (
          <TrazabilidadPorLote Datos={Datos} />
        )}
      </div>

      {showQRScanner && (
        <ScannerUnico
          isActive={showQRScanner && !Entrolectura}
          onScan={!Entrolectura ? handleQRScan : null}
          onClose={closeQRScanner}
          key={`qr-${Date.now()}`}
        />
      )}
    </>
  );
}
